/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useEffect,
  useRef,
} from "react";

import input from "../../assets/styles/components/input.module.css";
import styles from "./InputSuspense.module.css";

type props = {
  name?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e?: any) => void;
  onKeyDown?: (e?: any) => void;
  onClick?: (e?: any) => void;
  option?: ReactNode;
  disabled?: boolean;
  required?: boolean;
  isActiveDropDown: boolean;
  setIsActiveDropDown: Dispatch<SetStateAction<boolean>>;
  readOnly?: boolean;
};

const InputSuspense = ({
  name,
  label,
  onChange,
  onKeyDown,
  onClick,
  isActiveDropDown,
  option,
  placeholder,
  value,
  disabled = false,
  required,
  setIsActiveDropDown,
  readOnly,
}: props) => {

  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsActiveDropDown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickInput = () => {
    setIsActiveDropDown(true);
    onClick?.();
  };

  return (
    <div className={styles.inputDropdown} ref={dropdownRef}>
      <div>
        <label htmlFor={name}>{label}</label>
        <input
          name={name}
          className={input.input}
          placeholder={placeholder}
          onChange={onChange}
          value={value || ""}
          onClick={handleClickInput}
          autoComplete="off"
          onKeyDown={onKeyDown}
          type="search"
          required={required}
          disabled={disabled}
          readOnly={readOnly}
        />
      </div>
      {isActiveDropDown && <div className={styles.dropDown}>{option}</div>}
    </div>
  );
};

export default InputSuspense;
